var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0669 53.0666C58.5862 47.5472 62 39.9223 62 31.5C62 23.0777 58.5862 15.4527 53.0668 9.9333C47.5474 4.41385 39.9224 1 31.5 1C23.0777 1 15.4527 4.41383 9.93324 9.93324C4.41383 15.4527 1 23.0777 1 31.5C1 39.9223 4.41379 47.5473 9.93315 53.0667C15.4526 58.5861 23.0776 62 31.5 62C39.9224 62 47.5475 58.5861 53.0669 53.0666Z",
    fill: "url(#paint0_radial_840_3214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5087 22.5087L9.93324 9.93324M9.92748 9.92748L9.93324 9.93324M40.4914 22.5087L53.0668 9.9333M53.0726 9.92748L53.0668 9.9333M40.4914 40.4911L53.0669 53.0666M53.0726 53.0723L53.0669 53.0666M22.5087 40.4911L9.93315 53.0667M9.92748 53.0723L9.93315 53.0667M53.0669 53.0666C58.5862 47.5472 62 39.9223 62 31.5C62 23.0777 58.5862 15.4527 53.0668 9.9333M53.0669 53.0666C47.5475 58.5861 39.9224 62 31.5 62C23.0776 62 15.4526 58.5861 9.93315 53.0667M9.93315 53.0667C4.41379 47.5473 1 39.9223 1 31.5C1 23.0777 4.41383 15.4527 9.93324 9.93324M9.93324 9.93324C15.4527 4.41383 23.0777 1 31.5 1C39.9224 1 47.5474 4.41385 53.0668 9.9333M44.2083 31.5C44.2083 38.5186 38.5186 44.2083 31.5 44.2083C24.4814 44.2083 18.7917 38.5186 18.7917 31.5C18.7917 24.4814 24.4814 18.7917 31.5 18.7917C38.5186 18.7917 44.2083 24.4814 44.2083 31.5Z",
    stroke: "#D85159",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22614 9.22614C15.1335 3.31874 23.1457 8.96288e-07 31.5 0C39.8543 -8.96288e-07 47.8665 3.31874 53.7739 9.22613L39.6104 23.3896C37.4594 21.2385 34.542 20.0301 31.5 20.0301C28.458 20.0301 25.5406 21.2385 23.3896 23.3896L9.22614 9.22614Z",
    fill: "url(#paint1_radial_840_3214)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.774 53.7739C47.8666 59.6813 39.8544 63 31.5001 63C23.1458 63 15.1337 59.6813 9.22626 53.7739L23.3897 39.6104C25.5407 41.7615 28.4581 42.9699 31.5001 42.9699C34.5421 42.9699 37.4595 41.7615 39.6106 39.6104L53.774 53.7739Z",
    fill: "url(#paint2_radial_840_3214)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_840_3214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 31.5) rotate(90.4711) scale(41.2355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283175,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321851,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551704,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653383,
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776892,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_840_3214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 31.5) rotate(-89.1815) scale(35.0036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189652,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399853,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552325,
    stopColor: "#D85159",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675356,
    stopColor: "#D85159",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850447,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D85159"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_840_3214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5001 31.5) rotate(90.8185) scale(35.0036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189652,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399853,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552325,
    stopColor: "#D85159",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675356,
    stopColor: "#D85159",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850447,
    stopColor: "#D85159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D85159"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIcon3);
export default __webpack_public_path__ + "static/media/section-icon-3.4dbdd885d2488b301bbacfa6c3b5b96f.svg";
export { ForwardRef as ReactComponent };